export const iconFontAwesomeMoneyReceipt = (
	<i className="fa-solid fa-receipt"></i>
);
